import firebase from 'firebase/app'
import 'firebase/firestore'
import secondaryConfig from '../firebase.secondary.config'

let secondaryApp = null

export function getSecondaryFirestore() {
  if (!secondaryApp) {
    secondaryApp = firebase.initializeApp(secondaryConfig, 'secondary')
  }
  return secondaryApp.firestore()
}
